import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

export const getPages = async () => {
    try {
        const pagesCollection = collection(db, "pages");
        const snapshot = await getDocs(pagesCollection);
        const pagesData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
        }));
        return pagesData

    } catch (error) {
        console.error("Error fetching pages:", error);
        return [];
    }
};